import FullProductCard from "./FullProductCard";

export default FullProductCard;
